<!--
  theoretically we could use a style tag inside a noscript tag to show the nav when JS is disabled (rare case).
  but then we would show the desktop version which would require to have scroll-x set to auto.
  What in turn will make overflow-y hidden, which is a problem for us as we need to show the sub-menus
-->
<div class="header">
  @if (header.logo && header.logo.url) {
    <a
      class="header__home-link"
      [routerLink]="['/', currentLanguage]"
      [attr.aria-label]="'Header.Logo.Label' | translate"
      paiRipple
    >
      <pai-svg
        class="header__home-logo"
        [style.aspect-ratio]="logoAspectRatio"
        [url]="header.logo.url"
        aria-hidden="true"
      />
    </a>
  }
  <nav class="header__nav">
    <ul class="header__row" [attr.aria-label]="'Header.MainNav.Desc' | translate">
      @for (item of header.navigationItems; track item.id) {
        <li class="header__nav-item" [paiCmsId]="item">
          @if (item.__typename === 'NavigationParentItem') {
            <button
              class="header__nav-link header__nav-link--sub"
              paiRipple
              type="button"
              (click)="toggleSubNav(item)"
              [attr.aria-controls]="'submenu_' + item.id"
              [attr.aria-expanded]="isOpen(item)"
            >
              <span>{{ item.label }}</span>
              <pai-switching-chevron
                class="header__nav-link-arrow"
                [size]="16"
                [pointingDown]="!isOpen(item)"
                [finalStrokeWidth]="1.5"
              />
            </button>
            <div class="header__sub-nav" cdkMonitorSubtreeFocus (cdkFocusChange)="handleFocusChange($event, item)">
              @if (isOpen(item)) {
                <ul class="header__sub-nav-list" @slideDown [attr.id]="'submenu_' + item.id">
                  @for (subItem of item.items; track subItem.id) {
                    <li [paiCmsId]="subItem">
                      <a
                        class="header__sub-nav-link"
                        (click)="closeAllSubNavs()"
                        [paiCmsLink]="subItem.target"
                        paiCmsLinkActive="header__sub-nav-link--selected"
                        paiRipple
                      >
                        <span>{{ subItem.label }}</span>
                      </a>
                    </li>
                  }
                </ul>
              }
            </div>
          }
          @if (item.__typename === 'NavigationItem') {
            <a
              class="header__nav-link"
              (click)="closeAllSubNavs()"
              [paiCmsLink]="item.target"
              paiCmsLinkActive="header__nav-link--selected"
              paiRipple
            >
              <span>{{ item.label }}</span>
            </a>
          }
        </li>
      }
    </ul>

    <div class="header__row">
      @if (languages(); as languages) {
        <!-- todo use html-native popup for language selection -->
        <div class="header__lang-selection">
          <button
            class="header__lang-item"
            paiRipple
            type="button"
            (click)="toggleSubNav(languages)"
            [attr.aria-label]="'Header.LanguageSelection' | translate"
            aria-controls="submenu_languages"
            [attr.aria-expanded]="isOpen(languages)"
          >
            <pai-icon icon="globe-2" aria-hidden="true" />
          </button>
          @if (isOpen(languages)) {
            <ul
              class="header__lang-list"
              @slideLeft
              id="submenu_languages"
              [attr.aria-label]="'Header.LanguageSelection.List' | translate"
              cdkMonitorSubtreeFocus
              (cdkFocusChange)="handleFocusChange($event, languages)"
            >
              @for (lang of languages; track lang.id) {
                <li [paiCmsId]="lang" (click)="closeAllSubNavs()">
                  <a
                    class="header__lang-item"
                    [class.header__lang-item--selected]="lang.selected"
                    [attr.aria-selected]="lang.selected"
                    paiRipple
                    [attr.title]="lang.label"
                    [attr.aria-label]="lang.label"
                    [attr.hreflang]="lang.abbr"
                    [attr.href]="lang.altUrl"
                    >{{ lang.abbr | uppercase }}</a
                  >
                </li>
              }
            </ul>
          }
        </div>
      }

      <!-- use extra diff for the block-id (cms id) (otherwise it won't be selectable) -->
      @for (cta of header.cta; track cta.id) {
        <div [paiCmsId]="cta">
          <a class="header__cta" paiRipple [paiCmsLink]="cta.target"
            ><span>{{ cta.label }}</span></a
          >
        </div>
      }
    </div>
  </nav>

  <button
    class="header__burger"
    type="button"
    (click)="toggleSideNav()"
    [attr.aria-label]="'Header.ShowNavHint' | translate"
  >
    <pai-svg
      class="header__burger-icon"
      [url]="sideNav.isOpen() ? '/assets/icons/close.svg' : '/assets/icons/menu.svg'"
    />
  </button>
</div>
